import { render, staticRenderFns } from "./Kimono.vue?vue&type=template&id=d25331c6&"
import script from "./Kimono.vue?vue&type=script&lang=js&"
export * from "./Kimono.vue?vue&type=script&lang=js&"
import style0 from "./Kimono.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports